export function convertDoubleToHours(calledHourLoc) {
  if(calledHourLoc && calledHourLoc > 0) {
    let splitCalledHoutLoc = [
      (calledHourLoc > 0) ? Math.floor(calledHourLoc) : Math.ceil(calledHourLoc),
      calledHourLoc % 1
    ]

    let nDate = new Date(0,0)
    nDate.setSeconds(+splitCalledHoutLoc[1] * 60 * 60)

    if(nDate.getSeconds() >= 58 ) {
      nDate.setSeconds(0)
      nDate.setMinutes(nDate.getMinutes() + 1)
    }

    let calledHourLocResult = nDate.toTimeString().slice(2, 8)
    calledHourLocResult = splitCalledHoutLoc[0] == 0 ? "00" + calledHourLocResult : splitCalledHoutLoc[0] < 10 ? "0" + splitCalledHoutLoc[0] + calledHourLocResult : splitCalledHoutLoc[0] + calledHourLocResult
    calledHourLoc = calledHourLocResult

    if(calledHourLoc == '0')
      calledHourLoc = "00:00:00"
  } else if(calledHourLoc == '0')
    calledHourLoc = "00:00:00"
  
  return calledHourLoc
}